/**
 * Reveal the review form when a star rating element is clicked.
 *
 * @param {Element} starElement - The star element that was clicked.
 * @returns {void}
 */
function revealReviewForm(starElement) {
    const form = starElement.closest("form");

    if (!form) return;

    const reviewExpanded = form.querySelector(
        ".lux-product-review .lux-product-rating-review",
    );

    if (!reviewExpanded) return;

    if (!starElement.classList.contains("selected")) {
        reviewExpanded.classList.add("open");
    }
}

document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const star = target.closest(".lux-product-rating .rating");

    if (star) {
        revealReviewForm(star);
    }
});
